module.exports = __webpack_public_path__ + "img/sv21.e68c441b.svg";